import React from "react";
import { Loader2, Download } from "lucide-react";

export const PLANS = ["free", "starter", "professional", "enterprise"];
export const SUB_STATUSES = ["none", "trial", "active", "past_due", "suspended", "cancelled"];
export const SUPPORT_STATUSES = ["ok", "monitoring", "attention", "critical"];

export const PLAN_LABEL = { free: "Free", starter: "Starter", professional: "Professional", enterprise: "Enterprise" };
export const SUB_LABEL = {
  none: "Aucun", trial: "Essai", active: "Actif", past_due: "Impayé",
  suspended: "Suspendu", cancelled: "Annulé",
};
export const SUPPORT_LABEL = { ok: "OK", monitoring: "Surveillance", attention: "Attention", critical: "Critique" };

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("fr-FR") : "—");
export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—";

const SUB_COLORS = {
  active: "bg-emerald-100 text-emerald-700", trial: "bg-sky-100 text-sky-700",
  none: "bg-slate-100 text-slate-500", past_due: "bg-amber-100 text-amber-700",
  suspended: "bg-red-100 text-red-700", cancelled: "bg-slate-100 text-slate-500",
};
const SUPPORT_COLORS = {
  ok: "bg-emerald-100 text-emerald-700", monitoring: "bg-sky-100 text-sky-700",
  attention: "bg-amber-100 text-amber-700", critical: "bg-red-100 text-red-700",
};

export const SubBadge = ({ status }) => (
  <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${SUB_COLORS[status] || SUB_COLORS.none}`}>
    {SUB_LABEL[status] || status}
  </span>
);

export const SupportBadge = ({ status }) => (
  <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${SUPPORT_COLORS[status] || SUPPORT_COLORS.ok}`}>
    {SUPPORT_LABEL[status] || status}
  </span>
);

export const Loading = () => (
  <div className="flex items-center justify-center gap-2 py-16 text-sm text-slate-400" data-testid="admin-loading">
    <Loader2 size={16} className="animate-spin" /> Chargement…
  </div>
);

export const Empty = ({ label, testid }) => (
  <div className="rounded-2xl border border-slate-200 bg-white py-12 text-center text-sm text-slate-400" data-testid={testid}>
    {label}
  </div>
);

export const SectionHeader = ({ title, subtitle }) => (
  <div className="mb-5">
    <h2 className="font-heading text-xl font-bold text-[#17201A]">{title}</h2>
    {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
  </div>
);

export const Card = ({ children, className = "", ...rest }) => (
  <div className={`overflow-hidden rounded-2xl border border-slate-200 bg-white ${className}`} {...rest}>{children}</div>
);

const csvCell = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function downloadCsv(filename, headers, rows) {
  const lines = [headers.map(csvCell).join(",")];
  rows.forEach((r) => lines.push(r.map(csvCell).join(",")));
  const blob = new Blob(["\uFEFF" + lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export const ExportButton = ({ onClick, testid, label = "Exporter CSV" }) => (
  <button data-testid={testid} onClick={onClick}
    className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-600 hover:bg-slate-50">
    <Download size={14} /> {label}
  </button>
);
